<template>
  <div>
    <b-table-simple class="export-table m-0" borderless outlined style="border-bottom: 0 !important;">
      <b-thead>
        <b-tr class="title-row">
          <b-th colspan="4">{{ lodash.startCase($t('sale_notes.resumes.purchased_shrimp')) }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('sale_notes.shows.date')) }}</b-td>
          <b-td class="text-gray" style="width: 200px">: {{ trippedAt }}</b-td>
          <b-td style="width: 125px">{{ lodash.upperFirst($t('products.singular')) }}</b-td>
          <b-td class="text-gray">: {{ productServiceNames }}</b-td>
        </b-tr>
        <b-tr>
          <b-td>{{ lodash.upperFirst($t('sale_notes.partner')) }}</b-td>
          <b-td class="text-gray">: {{ partnerNames }}</b-td>
          <b-td>{{lodash.upperFirst($t('delivery_orders.order_id')) }}</b-td>
          <b-td class="text-gray">: {{ orderId }}</b-td>
        </b-tr>
        <b-tr>
          <b-td>{{ lodash.upperFirst($t('shipping_costs.to_factory')) }}</b-td>
          <b-td class="text-gray" colspan="3">: {{ factoryName }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-table-simple class="export-table" borderless outlined style="border-top: 0 !important;">
      <b-thead>
        <b-tr>
          <b-th style="width: 1%">No</b-th>
          <b-th>{{ lodash.startCase($t('sale_notes.resumes.product_name')) }}</b-th>
          <b-th>{{ `${$t('sale_notes.resumes.DoC')}` }}</b-th>
          <b-th>{{ `${lodash.startCase($t('sale_notes.resumes.biomass'))} (${$t('units.kg')})` }}</b-th>
          <b-th style="text-align: right">{{ `${lodash.startCase($t('sale_notes.resumes.price'))} (/${$t('units.kg')})` }}</b-th>
          <b-th style="text-align: right">{{ lodash.startCase($t('sale_notes.resumes.amount')) }}</b-th>
          <b-th>{{ lodash.startCase($t('sale_notes.resumes.fiber_label'))}}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, index) in tableItems" v-bind:key="index">
          <b-td>{{ index + 1 }}</b-td>
          <b-td>{{ item.name }}</b-td>
          <b-td>{{ item.doc }}</b-td>
          <b-td>{{ item.biomass }}</b-td>
          <b-td style="text-align: right">{{ item.price }}</b-td>
          <b-td style="text-align: right">{{ item.total_price }}</b-td>
          <b-td>{{ item.label }}</b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-td></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td :class="{
            'text-success': totalBiomass > 0,
             'text-danger': totalBiomass < 0
          }"><b>{{ lodash.startCase(`${decimalFormatter(totalBiomass)} ${$t('units.kg')}`) }}</b></b-td>
          <b-td></b-td>
          <b-td :class="{
            'text-success': totalBiomass > 0,
             'text-danger': totalBiomass < 0
          }" style="text-align: right"><b>{{ currencyFormatter(totalPrice) }}</b></b-td>
          <b-td :class="{
            'text-success': totalBiomass > 0,
             'text-danger': totalBiomass < 0
          }"><b>{{ lodash.startCase(`${decimalFormatter(totalBox > 0 ? totalBox : totalBoxFromDO)} ${$t('sale_notes.resumes.fiber')}`) }}</b></b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'trip-export',
  props: {
    purchaseOrders: {type: Array, default: function () { return {} }},
    totalBox: {type: Number, default: 0},
    value: {type: Object, default: function () { return [] }},
  },
  computed: {
    factoryName() {
      return this.value?.customer?.name || '-'
    },
    trippedAt() {
      if (!this.value?.tripped_at) return '-'
      return this.$moment.utc(this.value.tripped_at).local().format('DD MMMM YYYY')
    },
    orderId() {
      return this.value?.delivery_order?.id || '-'
    },
    partnerNames() {
      let customerNames = this.purchaseOrders?.map(({ customer: { name }}) => name)
      if (!customerNames.length) return '-'
      return this.lodash.uniq(customerNames).join(', ')
    },
    productServiceNames() {
      let names = this.purchaseOrders?.map(({sub_product_name}) => sub_product_name)
      if (!names.length) return '-'
      return this.lodash.uniq(names).join(', ')
    },
    tableItems() {
      return this.value?.trip_items.map(({
        purchase_item: { quality, doc },
        size,
        quantity,
        unit_price,
        total_price,
        label,
      }) => ({
        name: `Vannamei/${this.qualityFormatter(quality)}/Size ${size}`,
        doc: doc ?? '-',
        biomass: quantity,
        size: size,
        price: this.currencyFormatter(unit_price),
        total_price: this.currencyFormatter(total_price),
        label: this.lodash.upperFirst(label.toLowerCase()),
      }))
    },
    totalBiomass () {
      return this.value?.trip_item_total_quantity || 0
    },
    totalBoxFromDO() {
      return this.value?.delivery_order?.delivery_item_total_packing || 0
    },
    totalPrice() {
      return this.value?.trip_item_total || 0
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>